import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Criar instância do axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Verificar se é um erro de autorização de liberação (não redirecionar)
      const isLiberacaoConfirm = error.config?.url?.includes('/liberacoes/') && error.config?.url?.includes('/confirmar');
      const isLiberacaoCreate = error.config?.url?.includes('/liberacoes') && error.config?.method === 'post';
      const isSenhaIncorreta = error.response?.data?.message?.includes('Senha de liberação incorreta') || 
                               error.response?.data?.message?.includes('Senha incorreta');
      
      if ((isLiberacaoConfirm || isLiberacaoCreate) && isSenhaIncorreta) {
        // Não redirecionar - deixar o ModalAutorizacao lidar com o erro
        return Promise.reject(error);
      }
      
      // Para outros erros 401, redirecionar para login (token inválido/expirado)
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;